import React from "react";
import visa from "../../assets/images/Visa.png";
import Mastercard from "../../assets/images/Mastercard.png";
import AmericanExpress from "../../assets/images/AmericanExpress.png";
import Unionpay from "../../assets/images/unionpay.png";
import payattitude from "../../assets/images/Payattitude.png";
const Gateway = () => {
  const tablebody = [
    {
      Ash: "##",
      schemeName: "Refund",
      schemeShortName: "Refund",
      isEnabled: "Yes",
    },
    {
      Ash: "##",
      schemeName: "Reversal",
      schemeShortName: "Reversal",
      isEnabled: "Yes",
    },
    {
      Ash: "##",
      schemeName: "Card on file",
      schemeShortName: "Card on file",
      isEnabled: "Yes",
    },
    {
      Ash: "##",
      schemeName: "Payattitude on file",
      schemeShortName: "Payattitude on file",
      isEnabled: "No",
    },
    {
      Ash: "##",
      schemeName: "n/a",
      schemeShortName: "n/a",
      isEnabled: "n/a",
    },
  ];
  return (
    <div className="">
      <h1 className="text-2xl font-bold pb-4">
        Configurations - Gateway Services
      </h1>
      <div className="bg-white h-[924px] py-5 px-[4rem] rounded-md">
        <section className="flex justify-between px-5 items-center border rounded-t-md w-full p-3">
          <div className="text-orange-400 text-[20px] font-semibold">
            Add Gateway Service
          </div>
          <div>
            <svg
              width="12"
              height="6"
              viewBox="0 0 12 6"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.5 0.75L6 5.25L10.5 0.75"
                stroke="#464255"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </section>
        <section className="flex">
          <div className="p-5 w-[60%] gap-5 flex flex-col">
            <p className="text-2xl font-medium">Service details</p>
            <p className="text-sm font-normal py-">
              Enter a name for this card scheme and a few required inputs. You
              can <br /> make changes to this much later.
            </p>
            <div className="relative bg-gray-300 w-[134px] h-[134px] rounded-[50%]">
              <div className="absolute top-14 left-[40%]">
                <svg
                  width="27"
                  height="24"
                  viewBox="0 0 27 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M20.844 4.61748C20.898 4.70838 20.9925 4.77331 21.114 4.77331C24.354 4.77331 27 7.31848 27 10.435V18.1484C27 21.265 24.354 23.8102 21.114 23.8102H5.886C2.6325 23.8102 0 21.265 0 18.1484V10.435C0 7.31848 2.6325 4.77331 5.886 4.77331C5.994 4.77331 6.102 4.72137 6.1425 4.61748L6.2235 4.46165C6.27005 4.3673 6.31783 4.27039 6.36634 4.172C6.71169 3.47152 7.09375 2.69658 7.3305 2.24112C7.9515 1.07242 9.0045 0.423142 10.314 0.410156H16.6725C17.982 0.423142 19.0485 1.07242 19.6695 2.24112C19.8821 2.65021 20.2061 3.30921 20.5184 3.94433C20.5828 4.0753 20.6467 4.20526 20.709 4.3318L20.844 4.61748ZM19.8584 9.60368C19.8584 10.253 20.3984 10.7724 21.0734 10.7724C21.7484 10.7724 22.302 10.253 22.302 9.60368C22.302 8.95441 21.7484 8.422 21.0734 8.422C20.3984 8.422 19.8584 8.95441 19.8584 9.60368ZM11.164 11.6166C11.7985 11.0063 12.622 10.6817 13.4995 10.6817C14.377 10.6817 15.2005 11.0063 15.8215 11.6036C16.4425 12.201 16.78 12.9931 16.78 13.8372C16.7665 15.5772 15.3085 16.9927 13.4995 16.9927C12.622 16.9927 11.7985 16.668 11.1775 16.0707C10.5565 15.4733 10.219 14.6812 10.219 13.8372V13.8242C10.2055 13.0061 10.543 12.214 11.164 11.6166ZM17.2393 17.4471C16.2808 18.3691 14.9578 18.9404 13.4998 18.9404C12.0823 18.9404 10.7593 18.408 9.74678 17.4471C8.74778 16.4732 8.19428 15.2006 8.19428 13.8371C8.18078 12.4866 8.73428 11.214 9.73328 10.2401C10.7458 9.2662 12.0823 8.73379 13.4998 8.73379C14.9173 8.73379 16.2538 9.2662 17.2528 10.2271C18.2518 11.201 18.8053 12.4866 18.8053 13.8371C18.7918 15.2525 18.1978 16.5251 17.2393 17.4471Z"
                    fill="#030229"
                  />
                </svg>
              </div>
            </div>
            <div className="flex flex-col gap-2 ">
              <label htmlFor="scheme" className="text-[16px]">
                Name of Service
              </label>
              <input
                className="h-[50px] bg-gray-200 w-[80%] rounded-md p-4"
                name="scheme"
                placeholder="Example:Visa"
                type="text"
              />
            </div>
            <div className="flex flex-col gap-2 ">
              <label htmlFor="shortname" className="text-[16px]">
                Service Shortname
              </label>
              <input
                className="h-[50px] bg-gray-200 w-[80%] rounded-md p-4"
                name="shortname"
                type="text"
              />
            </div>
            <div className="flex gap-1">
              <input className="flex" type="checkbox" />
              <div className="">isEnabled</div>
            </div>
            <div className="w-[40%] bg-orange-500 text-white flex justify-center p-2 rounded-md">
              Save Services
            </div>
          </div>
          <div className="w-[40%] bg-white shadow-lg">
            <h1 className="text-[20px] font-medium p-5"> Gateway Services</h1>
            <div className="flex justify-between p-5 border-2">
              <span className="w-[40%] flex items-center justify-between text-sm font-semibold">
                SERVICE
                <svg
                  width="25"
                  height="24"
                  viewBox="0 0 25 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_3487_12916)">
                    <path
                      d="M18.5 13H13.5V18C13.5 18.55 13.05 19 12.5 19C11.95 19 11.5 18.55 11.5 18V13H6.5C5.95 13 5.5 12.55 5.5 12C5.5 11.45 5.95 11 6.5 11H11.5V6C11.5 5.45 11.95 5 12.5 5C13.05 5 13.5 5.45 13.5 6V11H18.5C19.05 11 19.5 11.45 19.5 12C19.5 12.55 19.05 13 18.5 13Z"
                      fill="#323232"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_3487_12916">
                      <rect
                        width="24"
                        height="24"
                        fill="white"
                        transform="translate(0.5)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </span>
              <span className=" border-x-2 px-3">1 Selected</span>
              <span className="w-[30%] flex items-center gap-6 gap justify-between">
                <span>
                  <svg
                    width="16"
                    height="15"
                    viewBox="0 0 16 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0.5 12.0504V14.5834C0.5 14.8167 0.683308 15 0.916609 15H3.44959C3.55791 15 3.66623 14.9583 3.74122 14.875L12.84 5.78461L9.71539 2.66005L0.624983 11.7505C0.541661 11.8338 0.5 11.9338 0.5 12.0504ZM15.2563 3.36828C15.5812 3.04333 15.5812 2.5184 15.2563 2.19345L13.3066 0.243716C12.9816 -0.0812387 12.4567 -0.0812387 12.1317 0.243716L10.6069 1.7685L13.7315 4.89307L15.2563 3.36828Z"
                      fill="#1C1C1C"
                    />
                  </svg>
                </span>
                <span>
                  <svg
                    width="15"
                    height="17"
                    viewBox="0 0 15 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M14.375 2.75H0.625C0.279822 2.75 0 3.02982 0 3.375C0 3.72018 0.279822 4 0.625 4H14.375C14.7202 4 15 3.72018 15 3.375C15 3.02982 14.7202 2.75 14.375 2.75Z"
                      fill="#1C1C1C"
                    />
                    <path
                      d="M5 7.125V12.125C5 12.4702 5.27982 12.75 5.625 12.75C5.97018 12.75 6.25 12.4702 6.25 12.125V7.125C6.25 6.77982 5.97018 6.5 5.625 6.5C5.27982 6.5 5 6.77982 5 7.125Z"
                      fill="#1C1C1C"
                    />
                    <path
                      d="M8.75 7.125V12.125C8.75 12.4702 9.02982 12.75 9.375 12.75C9.72018 12.75 10 12.4702 10 12.125V7.125C10 6.77982 9.72018 6.5 9.375 6.5C9.02982 6.5 8.75 6.77982 8.75 7.125Z"
                      fill="#1C1C1C"
                    />
                    <path
                      d="M2.5 15.25V3.375C2.5 3.02982 2.22018 2.75 1.875 2.75C1.52982 2.75 1.25 3.02982 1.25 3.375V15.25C1.25 15.7678 1.61612 16.1339 1.61612 16.1339C1.98223 16.5 2.5 16.5 2.5 16.5H12.5C13.0178 16.5 13.3839 16.1339 13.3839 16.1339C13.75 15.7678 13.75 15.25 13.75 15.25V3.375C13.75 3.02982 13.4702 2.75 13.125 2.75C12.7798 2.75 12.5 3.02982 12.5 3.375V15.25H2.5Z"
                      fill="#1C1C1C"
                    />
                    <path
                      d="M4.29918 0.799175C3.75 1.34835 3.75 2.125 3.75 2.125V3.375C3.75 3.72018 4.02982 4 4.375 4C4.72018 4 5 3.72018 5 3.375V2.125C5 1.86612 5.18306 1.68306 5.18306 1.68306C5.36612 1.5 5.625 1.5 5.625 1.5H9.375C9.63388 1.5 9.81694 1.68306 9.81694 1.68306C10 1.86612 10 2.125 10 2.125V3.375C10 3.72018 10.2798 4 10.625 4C10.9702 4 11.25 3.72018 11.25 3.375V2.125C11.25 1.34835 10.7008 0.799175 10.7008 0.799175C10.1517 0.25 9.375 0.25 9.375 0.25H5.625C4.84835 0.25 4.29918 0.799175 4.29918 0.799175Z"
                      fill="#1C1C1C"
                    />
                  </svg>
                </span>
                <span>
                  <svg
                    width="13"
                    height="4"
                    viewBox="0 0 13 4"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1.5 0.75C2.19036 0.75 2.75 1.30964 2.75 2C2.75 2.69036 2.19036 3.25 1.5 3.25C0.809644 3.25 0.25 2.69036 0.25 2C0.25 1.30964 0.809644 0.75 1.5 0.75Z"
                      fill="#1C1C1C"
                    />
                    <path
                      d="M6.5 0.75C7.19036 0.75 7.75 1.30964 7.75 2C7.75 2.69036 7.19036 3.25 6.5 3.25C5.80964 3.25 5.25 2.69036 5.25 2C5.25 1.30964 5.80964 0.75 6.5 0.75Z"
                      fill="#1C1C1C"
                    />
                    <path
                      d="M12.75 2C12.75 1.30964 12.1904 0.75 11.5 0.75C10.8096 0.75 10.25 1.30964 10.25 2C10.25 2.69036 10.8096 3.25 11.5 3.25C12.1904 3.25 12.75 2.69036 12.75 2Z"
                      fill="#1C1C1C"
                    />
                  </svg>
                </span>
              </span>
            </div>
            <table className="w-[100%]">
              <thead>
                <tr className="text-left border-b-2">
                  <th className="text-[12px] font-normal text-black-shade/40 border-r p-3">
                    <div className="flex items-center gap-2">
                      <input
                        type="checkbox"
                        className="w-[13.5px] h-[13.5px]"
                      />
                      <p>Logo</p>
                    </div>
                  </th>
                  <th className="text-[12px] font-normal text-black-shade/40 border-r px-3">
                    <p className="w-[54px]">Service Name</p>
                  </th>
                  <th className="text-[12px] font-normal text-black-shade/40 border-r px-3">
                    <p className="w-[54px]">Service Shortname</p>
                  </th>
                  <th className="text-[12px] font-normal text-black-shade/40  px-3">
                    isEnabled
                  </th>
                </tr>
              </thead>
              <tbody className="">
                {tablebody.map((t) => (
                  <tr className=" border-b-2">
                    <td className="p-3 text-black-shade/40 border-r">
                      <div className="flex gap-3 ">
                        <input type="checkbox" />
                        <section className="flex items-center">
                          {t.Ash}{" "}
                        </section>
                      </div>
                    </td>
                    <td className="text-[12px] w-[54px] text-black-shade/40 border-r p-3">
                      {t.schemeName}
                    </td>
                    <td className="text-[12px] w-[54px] text-black-shade/40 border-r p-3">
                      {t.schemeShortName}
                    </td>
                    <td className="text-[12px] text-black-shade/40 p-3">
                      {t.isEnabled}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Gateway;
